import React from "react";
import SEO from "../components/SEO";
import { PAGES } from "../seo/pages.config";
import ContactMain from "../components/ContactMain";
import FooterOne from "../components/FooterFour";
import NavBar from "../components/NavbarTwo";

const Contact = () => {
  return (
    <>
      <SEO canonical="/contact" {...PAGES["/contact"]} />
      <NavBar />
      <ContactMain />
      <FooterOne />
    </>
  );
};

export default Contact;
